export default __webpack_public_path__ + "static/media/solidario8.8e504920.jpeg";